import { useApolloClient } from '@apollo/client'
import { withRouter } from 'react-router'
import { useAuthorization } from '../../services/authorization'
import { LINKS } from '../../constants'

const LogoutPage = ({ history }) => {
  const [, , , clearAuthTokens] = useAuthorization()
  const apolloClient = useApolloClient()
  const logout = async () => {
    await apolloClient.clearStore()
    clearAuthTokens()
    history.push(LINKS.LOGIN)
  }

  logout()

  return null
}

export default withRouter(LogoutPage)
